import { garconClient } from "@apis/axiosClients"

export const getUsersWithEmail = async (callback) => {
  try {
    const response = await garconClient.get(
      `${import.meta.env.VITE_GARCON_API}/users`,
    )
    const internalUsers = response.data.filter(
      (user) =>
        user.email !== null && user.email.includes("inspirecleanenergy.com"),
    )
    callback(internalUsers)
  } catch (error) {
    console.error("Request error:", error)
  }
}

export const getAllUsers = async (callback) => {
  try {
    const response = await garconClient.get(
      `${import.meta.env.VITE_GARCON_API}/users`,
    )
    callback(response.data)
  } catch (error) {
    console.error("Request error:", error)
  }
}
